import { render, staticRenderFns } from "./QuiltyResourceGeneralView.vue?vue&type=template&id=4340986e&"
import script from "./QuiltyResourceGeneralView.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceGeneralView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports